import { inject, InjectionToken } from '@angular/core';
import { submissionSetupSignalStore } from '../signal-stores';

import { SubmissionSetupSignalState } from '../../types/submission-setup.types';

export const SUBMISSION_SETUP_TOKEN =
  new InjectionToken<SubmissionSetupSignalState>('Submission Setup Token');

export const SUBMISSION_SETUP_PROVIDER = {
  provide: SUBMISSION_SETUP_TOKEN,
  useClass: submissionSetupSignalStore,
};

export function submissionSetupTokenizer() {
  return inject(SUBMISSION_SETUP_TOKEN);
}


